import React from 'react';
import { motion } from 'framer-motion';
import StatCard from './ui/StatCard';
import { Briefcase as _lr_Briefcase, Users as _lr_Users, CalendarCheck as _lr_CalendarCheck, Award as _lr_Award } from 'lucide-react';

const Briefcase = _lr_Briefcase || (() => null);
const Users = _lr_Users || (() => null);
const CalendarCheck = _lr_CalendarCheck || (() => null);
const Award = _lr_Award || (() => null);
const kpis = [
  { label: 'Open Roles', value: '6', change: '+2 this month', trend: 'up', icon: Briefcase, meta: 'Across 4 departments' },
  { label: 'Total Candidates', value: '182', change: '+24 this week', trend: 'up', icon: Users, meta: '10 shortlisted' },
  { label: 'Interviews Scheduled', value: '14', change: '+5 vs last week', trend: 'up', icon: CalendarCheck, meta: 'Next 7 days' },
  { label: 'Offers Extended', value: '3', change: '1 accepted', trend: 'neutral', icon: Award, meta: 'This quarter' },
];

export function StatsCards() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {kpis.map((kpi, i) => (
        <motion.div key={kpi.label} initial={{ opacity: 1, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.08 }}>
          <StatCard label={kpi.label} value={kpi.value} change={kpi.change} trend={kpi.trend} icon={kpi.icon} meta={kpi.meta} />
        </motion.div>
      ))}
    </div>
  );
}

export default StatsCards;